import { useReducer } from 'react'
import { message } from 'antd'
import { GetLocalStorage } from '../../../../tools/util'
import {
  DOWNLOAD_ORDER_FILE,
  DOWNLOAD_SUPPLIERORDERCONTRACT,
  UPLOAD_SIGN_VOUCHER,
  DELETE_SIGN_VOUCHER,
  UPLOAD_FILES_NO_SAVE,
  SignVoucherFileItem,
  SignVoucherUploadFileItem,
} from '../../../../api/orderManage'
import { isResponseCodeSuccess } from '../../../../tools/util'

// 订单附件
export interface AnnexItem {
  baseUrl: string
  id: string
  name: string
  type: string
  url: string
}

export interface SupplierOrderReceiveInfoItem {
  id: string
  receiveMan: string
  receiveMobile: string
  receiveAddress: string
  receiveRemark: string
}

export interface Props {
  infoObj: {
    annexDTOs?: AnnexItem[]
    cancelReturnPrice: number
    code: string
    detailedProductDTOList: any[]
    directShipment: boolean
    finalPrice: number
    groupName: string
    id: string
    orderCreateTime: string
    orderState: string
    price: number
    purchaseGroupName: string
    receiveAddress: string
    receiveMan: string
    receiveMobile: string
    warehousingProgress: string
    orderStateToName: string
    purchaseMan: string
    remark: string
    customerOrderCode: string
    refuseReason: string
    refuseState: boolean
    supplierName: string
    contractFiles: any
    confirmState: string
    scpShipStatusName: string
    scpShipStatus: string
    receiveInfoList?: SupplierOrderReceiveInfoItem[]
    orderType?: string
    signVoucherFiles?: SignVoucherFileItem[]
    signVoucherState?: string
    signVoucherRejectReason?: string
    signVoucherTime?: string
    allShipped?: boolean
  }
  confirmOrder: () => void
  rejectOrder: () => void
  cancelTime: any
  productList: any[]
  onRefreshDetail?: () => void
}

export const invoicingStateDict: any = {
  '1': '已开票',
  '2': '未开票',
}

interface State {
  isPreviewModalVisible: boolean
  previewFileUrl: string
  uploading: boolean
}

type ActionType =
  | 'setIsPreviewModalVisibleAction'
  | 'setPreviewFileUrlUrlAction'
  | 'setUploadingAction'

interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  isPreviewModalVisible: false,
  previewFileUrl: '',
  uploading: false,
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'setUploadingAction':
      newstate.uploading = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

// 预览弹窗
const setIsPreviewModalVisibleAction = (val: boolean): Action => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

// 预览文件url
const setPreviewFileUrlUrlAction = (val: string): Action => ({
  type: 'setPreviewFileUrlUrlAction',
  payload: val,
})

const setUploadingAction = (val: boolean): Action => ({
  type: 'setUploadingAction',
  payload: val,
})

// 不可预览的文件类型
const NON_PREVIEWABLE_TYPES = ['zip', 'rar', '7z']

const ACCEPT_TYPES = '.pdf,.jpg,.png,.zip,.rar,.7z'
const MAX_COUNT = 5

export default function useHook(props: Props) {
  const {
    infoObj,
    confirmOrder,
    cancelTime,
    rejectOrder,
    onRefreshDetail,
    productList,
  } = props
  const [state, dispatch] = useReducer(reducer, initialState)
  const { previewFileUrl, isPreviewModalVisible, uploading } = state

  // 预览
  const showPreviewModal = (item: AnnexItem) => {
    dispatch(setPreviewFileUrlUrlAction(GetLocalStorage('BASEURL') + item.url))
    dispatch(setIsPreviewModalVisibleAction(true))
  }

  // 取消预览
  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisibleAction(false))
  }

  // 下载附件
  const onDownloadFile = (item: AnnexItem) => {
    DOWNLOAD_ORDER_FILE({
      url: item.url,
      fileName: item.name,
    })
  }

  const downLoadTemplate = async () => {
    await DOWNLOAD_SUPPLIERORDERCONTRACT({ orderId: infoObj.id })
  }
  // 签收凭证相关
  // 判断SRM后台采购订单是否全部入库：每个物料入库数量 = 数量 - 取消数量，且入库数量 > 0
  const allWarehouseCompleted =
    productList.length > 0 &&
    productList.every((item: any) => {
      const stockInputQty = Number(item.stockInputQty) || 0
      const expectedQty =
        (Number(item.num) || 0) - (Number(item.cancelQty) || 0)
      console.log(stockInputQty, 'stockInputQty')
      console.log(expectedQty, 'expectedQty')
      return stockInputQty > 0 && stockInputQty === expectedQty
    })

  const canShowVoucherBtn =
    infoObj.orderType === 'DB' &&
    infoObj.allShipped === true &&
    allWarehouseCompleted

  const isPending = infoObj.signVoucherState === '0'
  const isApproved = infoObj.signVoucherState === '1'
  const isRejected = infoObj.signVoucherState === '2'

  const voucherFileCount = infoObj.signVoucherFiles?.length || 0

  const hasVoucherFiles = voucherFileCount > 0

  const showUploadBtn =
    canShowVoucherBtn &&
    !isPending &&
    !isApproved &&
    (isRejected || voucherFileCount < MAX_COUNT)
  console.log(showUploadBtn, 'showUploadBtn')
  const uploadBtnText = isRejected ? '重新上传签收凭证' : '上传签收凭证'

  const handleUploadFiles = async (fileList: File[]) => {
    const existingCount = infoObj.signVoucherFiles?.length || 0
    if (existingCount + fileList.length > MAX_COUNT) {
      message.warning(
        `最多上传${MAX_COUNT}个文件，当前已有${existingCount}个，还能上传${MAX_COUNT - existingCount}个`,
      )
      return
    }
    dispatch(setUploadingAction(true))
    try {
      // 逐个上传文件到服务器
      const uploadedFiles: SignVoucherUploadFileItem[] = []
      for (const file of fileList) {
        const res = await UPLOAD_FILES_NO_SAVE(
          { type: 'account', code: infoObj.id },
          file,
        )
        if (isResponseCodeSuccess(res.code) && res.data) {
          uploadedFiles.push(
            ...res.data.map((item: any) => {
              const filename = item.name || file.name
              const newFilePath = item.url || ''
              return {
                filename,
                newFilePath,
                newFileName: filename,
                fileRes: `${filename};${newFilePath}`,
                baseUrl: item.baseUrl || '',
                type:
                  item.type || file.name.split('.').pop()?.toLowerCase() || '',
              } as SignVoucherUploadFileItem
            }),
          )
        }
      }
      if (uploadedFiles.length === 0) {
        message.error('文件上传失败')
        return
      }
      // 关联签收凭证到订单
      const res = await UPLOAD_SIGN_VOUCHER({
        orderId: infoObj.id,
        fileList: uploadedFiles,
      })
      if (isResponseCodeSuccess(res.code)) {
        message.success('上传成功')
        onRefreshDetail?.()
      }
    } finally {
      dispatch(setUploadingAction(false))
    }
  }

  const handleDeleteVoucher = async (id: string) => {
    const res = await DELETE_SIGN_VOUCHER({ id })
    if (isResponseCodeSuccess(res.code)) {
      message.success('删除成功')
      onRefreshDetail?.()
    }
  }

  const canPreviewFile = (item: SignVoucherFileItem) => {
    const ext = item.name?.split('.').pop()?.toLowerCase() || ''
    return !NON_PREVIEWABLE_TYPES.includes(ext)
  }

  return {
    infoObj,
    confirmOrder,
    cancelTime,
    previewFileUrl,
    showPreviewModal,
    isPreviewModalVisible,
    cancelPreviewModal,
    onDownloadFile,
    rejectOrder,
    downLoadTemplate,
    // 签收凭证
    canShowVoucherBtn,
    isPending,
    isApproved,
    isRejected,
    hasVoucherFiles,
    showUploadBtn,
    uploadBtnText,
    uploading,
    handleUploadFiles,
    handleDeleteVoucher,
    canPreviewFile,
    ACCEPT_TYPES,
    MAX_COUNT,
  }
}
import { useReducer } from 'react'
import { message } from 'antd'
import { GetLocalStorage } from '../../../../tools/util'
import {
  DOWNLOAD_ORDER_FILE,
  DOWNLOAD_SUPPLIERORDERCONTRACT,
  UPLOAD_SIGN_VOUCHER,
  DELETE_SIGN_VOUCHER,
  UPLOAD_FILES_NO_SAVE,
  SignVoucherFileItem,
  SignVoucherUploadFileItem,
} from '../../../../api/orderManage'
import { isResponseCodeSuccess } from '../../../../tools/util'

// 订单附件
export interface AnnexItem {
  baseUrl: string
  id: string
  name: string
  type: string
  url: string
}

export interface SupplierOrderReceiveInfoItem {
  id: string
  receiveMan: string
  receiveMobile: string
  receiveAddress: string
  receiveRemark: string
}

export interface Props {
  infoObj: {
    annexDTOs?: AnnexItem[]
    cancelReturnPrice: number
    code: string
    detailedProductDTOList: any[]
    directShipment: boolean
    finalPrice: number
    groupName: string
    id: string
    orderCreateTime: string
    orderState: string
    price: number
    purchaseGroupName: string
    receiveAddress: string
    receiveMan: string
    receiveMobile: string
    warehousingProgress: string
    orderStateToName: string
    purchaseMan: string
    remark: string
    customerOrderCode: string
    refuseReason: string
    refuseState: boolean
    supplierName: string
    contractFiles: any
    confirmState: string
    scpShipStatusName: string
    scpShipStatus: string
    receiveInfoList?: SupplierOrderReceiveInfoItem[]
    orderType?: string
    signVoucherFiles?: SignVoucherFileItem[]
    signVoucherState?: string
    signVoucherRejectReason?: string
    signVoucherTime?: string
    allShipped?: boolean
  }
  confirmOrder: () => void
  rejectOrder: () => void
  cancelTime: any
  productList: any[]
  onRefreshDetail?: () => void
}

export const invoicingStateDict: any = {
  '1': '已开票',
  '2': '未开票',
}

interface State {
  isPreviewModalVisible: boolean
  previewFileUrl: string
  uploading: boolean
}

type ActionType =
  | 'setIsPreviewModalVisibleAction'
  | 'setPreviewFileUrlUrlAction'
  | 'setUploadingAction'

interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  isPreviewModalVisible: false,
  previewFileUrl: '',
  uploading: false,
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'setUploadingAction':
      newstate.uploading = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

// 预览弹窗
const setIsPreviewModalVisibleAction = (val: boolean): Action => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

// 预览文件url
const setPreviewFileUrlUrlAction = (val: string): Action => ({
  type: 'setPreviewFileUrlUrlAction',
  payload: val,
})

const setUploadingAction = (val: boolean): Action => ({
  type: 'setUploadingAction',
  payload: val,
})

// 不可预览的文件类型
const NON_PREVIEWABLE_TYPES = ['zip', 'rar', '7z']

const ACCEPT_TYPES = '.pdf,.jpg,.png,.zip,.rar,.7z'
const MAX_COUNT = 5

export default function useHook(props: Props) {
  const {
    infoObj,
    confirmOrder,
    cancelTime,
    rejectOrder,
    onRefreshDetail,
    productList,
  } = props
  const [state, dispatch] = useReducer(reducer, initialState)
  const { previewFileUrl, isPreviewModalVisible, uploading } = state

  // 预览
  const showPreviewModal = (item: AnnexItem) => {
    dispatch(setPreviewFileUrlUrlAction(GetLocalStorage('BASEURL') + item.url))
    dispatch(setIsPreviewModalVisibleAction(true))
  }

  // 取消预览
  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisibleAction(false))
  }

  // 下载附件
  const onDownloadFile = (item: AnnexItem) => {
    DOWNLOAD_ORDER_FILE({
      url: item.url,
      fileName: item.name,
    })
  }

  const downLoadTemplate = async () => {
    await DOWNLOAD_SUPPLIERORDERCONTRACT({ orderId: infoObj.id })
  }
  // 签收凭证相关
  // 判断SRM后台采购订单是否全部入库：每个物料入库数量 = 数量 - 取消数量，且入库数量 > 0
  const allWarehouseCompleted =
    productList.length > 0 &&
    productList.every((item: any) => {
      const stockInputQty = Number(item.stockInputQty) || 0
      const expectedQty =
        (Number(item.num) || 0) - (Number(item.cancelQty) || 0)
      console.log(stockInputQty, 'stockInputQty')
      console.log(expectedQty, 'expectedQty')
      return stockInputQty > 0 && stockInputQty === expectedQty
    })

  const canShowVoucherBtn =
    infoObj.orderType === 'DB' &&
    infoObj.allShipped === true &&
    allWarehouseCompleted

  const isPending = infoObj.signVoucherState === '0'
  const isApproved = infoObj.signVoucherState === '1'
  const isRejected = infoObj.signVoucherState === '2'

  const voucherFileCount = infoObj.signVoucherFiles?.length || 0

  const hasVoucherFiles = voucherFileCount > 0

  const showUploadBtn =
    canShowVoucherBtn &&
    !isPending &&
    !isApproved &&
    (isRejected || voucherFileCount < MAX_COUNT)
  console.log(showUploadBtn, 'showUploadBtn')
  const uploadBtnText = isRejected ? '重新上传签收凭证' : '上传签收凭证'

  const handleUploadFiles = async (fileList: File[]) => {
    const existingCount = infoObj.signVoucherFiles?.length || 0
    if (existingCount + fileList.length > MAX_COUNT) {
      message.warning(
        `最多上传${MAX_COUNT}个文件，当前已有${existingCount}个，还能上传${MAX_COUNT - existingCount}个`,
      )
      return
    }
    dispatch(setUploadingAction(true))
    try {
      // 逐个上传文件到服务器
      const uploadedFiles: SignVoucherUploadFileItem[] = []
      for (const file of fileList) {
        const res = await UPLOAD_FILES_NO_SAVE(
          { type: 'account', code: infoObj.id },
          file,
        )
        if (isResponseCodeSuccess(res.code) && res.data) {
          uploadedFiles.push(
            ...res.data.map((item: any) => {
              const filename = item.name || file.name
              const newFilePath = item.url || ''
              return {
                filename,
                newFilePath,
                newFileName: filename,
                fileRes: `${filename};${newFilePath}`,
                baseUrl: item.baseUrl || '',
                type:
                  item.type || file.name.split('.').pop()?.toLowerCase() || '',
              } as SignVoucherUploadFileItem
            }),
          )
        }
      }
      if (uploadedFiles.length === 0) {
        message.error('文件上传失败')
        return
      }
      // 关联签收凭证到订单
      const res = await UPLOAD_SIGN_VOUCHER({
        orderId: infoObj.id,
        fileList: uploadedFiles,
      })
      if (isResponseCodeSuccess(res.code)) {
        message.success('上传成功')
        onRefreshDetail?.()
      }
    } finally {
      dispatch(setUploadingAction(false))
    }
  }

  const handleDeleteVoucher = async (id: string) => {
    const res = await DELETE_SIGN_VOUCHER({ id })
    if (isResponseCodeSuccess(res.code)) {
      message.success('删除成功')
      onRefreshDetail?.()
    }
  }

  const canPreviewFile = (item: SignVoucherFileItem) => {
    const ext = item.name?.split('.').pop()?.toLowerCase() || ''
    return !NON_PREVIEWABLE_TYPES.includes(ext)
  }

  return {
    infoObj,
    confirmOrder,
    cancelTime,
    previewFileUrl,
    showPreviewModal,
    isPreviewModalVisible,
    cancelPreviewModal,
    onDownloadFile,
    rejectOrder,
    downLoadTemplate,
    // 签收凭证
    canShowVoucherBtn,
    isPending,
    isApproved,
    isRejected,
    hasVoucherFiles,
    showUploadBtn,
    uploadBtnText,
    uploading,
    handleUploadFiles,
    handleDeleteVoucher,
    canPreviewFile,
    ACCEPT_TYPES,
    MAX_COUNT,
  }
}
